import SupportCaseAPI from '~/api/supportCaseApi';
import {Fragment, useEffect, useState} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons"
import { format } from "date-fns";
import {useParams} from "react-router-dom";

function CaseDetail(){
    const { id } = useParams();
    const params = new URLSearchParams({
        userId: '3bb73dc3-9a90-4bf7-949e-78ca159679c2',
        caseId: id,
    });
    const [caseDetails, setCaseDetails] = useState({
        SupportCase: {},
        CaseSessions: [],
        CaseChats: []
    });
    useEffect(() => {
        SupportCaseAPI.getCaseDetails(params)
            .then((res) => {
                setCaseDetails(res.data);
            })
            .catch((err) => {
                ;
            });
    }, []);

    return(
        <div className="row">
            <div className="col-12 col-xl-4">
                {
                    caseDetails.SupportCase.CaseId !== "" &&
                    (
                        <div className="bg-body-highlight rounded">
                            <ul className="list-unstyled px-3 py-3">
                                <li className="mb-3"> <span className="fw-bold fs-8-1">SUBJECT: </span> <span className="fs-8-1">{caseDetails.SupportCase.Subject}</span></li>
                                <li className="mb-3"> <span className="fw-bold fs-8-1">CASE ID: </span><span className="fs-8-1">{caseDetails.SupportCase.CaseId}</span></li>
                                <li className="mb-3"> <span className="fw-bold fs-8-1">CREATED DATE: </span><span className="fs-8-1">{caseDetails.SupportCase.CreatedDate && format(new Date(caseDetails.SupportCase.CreatedDate), "dd/MM/yyyy hh:mm:ss a")}</span></li>
                                <li className="mb-3"> <span className="fw-bold fs-8-1">CASE STATUS: </span><span className="fs-8-1">{caseDetails.SupportCase.CaseStatus}</span></li>
                                <li className="mb-3"> <span className="fw-bold fs-8-1">CASE TYPE: </span><span className="fs-8-1">{caseDetails.SupportCase.CaseType}</span></li>
                                <li className="mb-3"> <span className="fw-bold fs-8-1">OPENED BY: </span><span className="fs-8-1">{caseDetails.SupportCase.OpenedBy}</span></li>
                            </ul>
                        </div>
                    )
                }
            </div>
            <div className="col-12 col-xl-8 scrollbar">
                <div>
                    {
                        caseDetails.CaseSessions.map((caseSession, index) => (
                            <Fragment key={index}>
                                <h6 className="py-2 border-bottom mb-3 ms-8 text-center">{caseSession.CreatedBy} {format(new Date(caseSession.CreatedDate), "dd/MM/yyyy hh:mm:ss a")}</h6>
                                <div className="timeline-basic mb-9">
                                    {
                                        caseDetails.CaseChats
                                            .filter(x => (x.CaseSessionId === caseSession.CaseSessionId))
                                            .map((caseChat, index, arr) => (
                                                <div className='timeline-item' key={caseChat.CaseChatId}>
                                                    <div className="row g-3">
                                                        <div className="col-auto">
                                                            <div className="timeline-item-bar position-relative">
                                                                <div
                                                                    className="icon-item rounded-7 border border-translucent"
                                                                    style={{width: "2rem", height: "2rem"}}>
                                                                    <span className="fs-10">{index + 1}</span>
                                                                </div>
                                                                {index !== arr.length - 1 && (
                                                                    <span className="timeline-bar border-end border-dashed" style={{left: "16px", top: "36px"}}></span>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="col">
                                                            <div className="d-flex justify-content-between">
                                                                <div className="d-flex mb-2">
                                                                    <h6 className="lh-sm mb-0 me-2 text-body-secondary timeline-item-title">
                                                                        {caseChat.SupporterOrCustomer} - <span className="fs-9"> {format(new Date(caseChat.CreatedDate), "dd/MM/yyyy hh:mm:ss a")}</span>
                                                                    </h6>
                                                                </div>
                                                            </div>
                                                            <p className="fs-9 text-body-secondary w-sm-60 mb-3">{caseChat.ChatContent}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                    }
                                </div>
                            </Fragment>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

export default CaseDetail;